import {  DataFromUrl, EditJob, handleOtherResponseCode, REDIRECT, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, CustomToastrAction, JobOptionsService} from  '@/imports-files/pages/clients/jobs/job-options';

export class JobOptionsAction
{
  constructor(args)
  {
    this.jobOptionsService = new JobOptionsService();
  }

  async getJobOptionsData(setApiError){
    var job_id          =  new DataFromUrl().getJobId();
    const result        =  await this.jobOptionsService.getJobOptionsData(job_id);
    const job_result    =  await new EditJob().getJobInfo(job_id);
    if(result.request.status == 200){
      const job           =  job_result.data.job
      const data          =  {
                              props: {
                                      result: result.data,
                                      job: job
                                     }
                             }
      return data;
    }
    else{
      setApiError(job_result.request)
    }
  }


  async handleFormSubmit(values, router, t, setPageName, queryClient, formik, fromKanban, gotoKanban, setDisabledSaveButton, setShowLoader)
  {
    setDisabledSaveButton(true)
    let result  =  {}
    const jobId =  new DataFromUrl().getJobId() || values.job.id;
    let idRegex =  new RegExp("[0-9]")


    let screening_questions_attributes = values.job.screening_questions_attributes
    screening_questions_attributes = screening_questions_attributes.map((x) => {
      let order = 1
      x.question_options_attributes =  x.question_options_attributes.map((option) => {
        if(!option.option)
          option._destroy = true

        if(!option._destroy)
          option.order = order
        return option
      })
      return x
    })
    values.job.screening_questions_attributes = screening_questions_attributes
    let body = Object.assign({}, values)
     result = await this.jobOptionsService.addJobOptions(body, values.job.id)
    const status_code = result.status || result.response.status;
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      let queryPath = fromKanban ? "?from_kanban=true" : ""
      setShowLoader(false)
      if(gotoKanban){
        if(fromKanban){
          router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', response.id)});
        }
        else{
          router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'Active' } });
        }
      }
      else
      router.push(REDIRECT.client.jobs.interview_stages.replace('$job_id', response.id)+queryPath);
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      let message = "";
      if(result.response.data.error.job?.hiring_manager_emails){
        message +=  `${result.response.data.error.job.hiring_manager_emails}`
      }
      if(result.response.data.error.job?.job_owner_emails){
        if(message.length > 0) { message += "</br>"}
        message += `${result.response.data.error.job.job_owner_emails}`
      }
      if(result.response.data.error.job?.new_user_emails){
        if(message.length > 0) { message += "</br>"}
        message += `${result.response.data.error.job.new_user_emails}`
      }
      if(message.length > 0) { new CustomToastrAction().setNormalToastr(message, 'warning');
                             }
      const job_error = result.response.data.error
      delete job_error.job["hiring_manager_emails"]
      delete job_error.job["job_owner_emails"]
      formik.current.setStatus(job_error);
      formik.current.setErrors(job_error);
      setDisabledSaveButton(false)
      setShowLoader(false)
      break;
    default:
      handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false)
      setShowLoader(false)
    }
  }


}